var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Link } from '@ambiguous/link';
import Button from "../button/button";
export default function CardSm({ title, content, underscored, image, buttons, bg_color, url, url__props }) {
    const { id, url: src } = image || {};
    const bg_styles = bg_color ? { style: { backgroundColor: bg_color } } : null;
    const svg_styles = bg_color ? { style: { color: bg_color } } : null;
    return (React.createElement("div", { className: `ltg-card-sm` },
        React.createElement("div", Object.assign({ className: `ltg-card${!src ? ' ltg-card--no-img' : ''}` }, bg_styles),
            src && (React.createElement(Anchor, { url: url, blank: url__props === null || url__props === void 0 ? void 0 : url__props.blank, className: "ltg-card-img-wrap" },
                React.createElement("svg", Object.assign({ className: "ltg-card-mask", version: "1.1", viewBox: "0 0 673.67 481.3", xmlns: "http://www.w3.org/2000/svg" }, svg_styles),
                    React.createElement("path", { d: "m0 0v481.3h673.65l-598.48-0.45703c-3.0929 2e-3 -6.1818-0.22435-9.2415-0.67578-23.367-0.48693-44.699-13.373-55.973-33.809-11.274-20.436-10.777-45.32 1.3032-65.291 1.0018-2.519 1.7121-3.9102 1.7121-3.9102l171.42-262.21c55.677-84.721 104.57-113.21 189.52-113.11l6e-3 0.00586 299.73-1.8359v-0.0078131z", fill: 'currentColor' })),
                React.createElement("img", { className: "ltg-card-img", src: src, alt: title }))),
            React.createElement("div", { className: "ltg-card-text-wrap" },
                React.createElement("div", { className: 'ltg-card-text-content' },
                    React.createElement(Anchor, { url: url, blank: url__props === null || url__props === void 0 ? void 0 : url__props.blank, className: "ltg-card-title-wrap" },
                        React.createElement("h2", { role: "presentation", className: "ltg-card-title" },
                            React.createElement("span", { className: !!underscored ? 'ltg-card-underscored' : '' }, title)),
                        url && (React.createElement("i", { className: "fas fa-chevron-right ltg-card-title-chevron" }))),
                    content && React.createElement("div", { className: "ltg-card-description", dangerouslySetInnerHTML: { __html: content } }),
                    buttons && React.createElement(ButtonWrap, { buttons: buttons }))))));
    function ButtonWrap({ buttons }) {
        return (React.createElement("div", { className: "ltg-card-button-wrap" }, buttons && buttons.map((_a) => {
            var { _id } = _a, rest = __rest(_a, ["_id"]);
            return (React.createElement(Button, Object.assign({ key: _id }, rest)));
        })));
    }
}
function Anchor({ url, blank, className, children }) {
    if (url) {
        return (React.createElement(Link, { href: url, target: blank ? '_blank' : null, rel: blank ? 'noreferrer noopener nofollow' : null, className: className }, children));
    }
    return React.createElement("div", { className: className }, children);
}
